(()=>{
  if(window.AWAInstallationCoverage)return;
  const australianPostcodeRanges=[['0200','0299'],['0800','0999'],['1000','2599'],['2600','2619'],['2620','2899'],['2900','2920'],['2921','2999'],['3000','3999'],['4000','4999'],['5000','5999'],['6000','6999'],['7000','7999'],['8000','8999'],['9000','9999']];
  const postcodePattern=/^[0-9]{4}$/;
  const normaliseDashes=value=>String(value??'').replace(/[\u2013\u2014]/g,'-');
  const isAustralianPostcode=value=>{
    const postcode=String(value??'').trim();
    if(!postcodePattern.test(postcode)||postcode==='0000')return false;
    return australianPostcodeRanges.some(([start,end])=>postcode>=start&&postcode<=end);
  };
  const parseRules=value=>{
    const tokens=normaliseDashes(value).split(/[\r\n,]+/).map(token=>token.trim()).filter(Boolean),included=[],excluded=[],errors=[];
    tokens.forEach(token=>{
      const isExclusion=token.startsWith('!'),body=isExclusion?token.slice(1).trim():token,match=body.match(/^([0-9]{4})(?:\s*-\s*([0-9]{4}))?$/);
      if(!match){errors.push({token,reason:'format'});return}
      const start=match[1],end=match[2]||match[1];
      if(start>end){errors.push({token,reason:'reversed'});return}
      if(!isAustralianPostcode(start)||!isAustralianPostcode(end)){errors.push({token,reason:'invalid_postcode'});return}
      (isExclusion?excluded:included).push({start:Number(start),end:Number(end)});
    });
    return{configured:included.length>0,valid:errors.length===0&&included.length>0,included,excluded,errors};
  };
  const contains=(intervals,postcode)=>{
    const number=Number(postcode);
    return intervals.some(interval=>number>=interval.start&&number<=interval.end);
  };
  const evaluate=(profile,postcode)=>{
    const value=String(postcode??'').trim(),parsed=profile?.parsed||parseRules(profile?.rules);
    if(profile?.enabled!==true||!parsed.configured||!parsed.valid)return{available:null,state:'not_configured',reason:parsed.errors.length?'invalid_rules':'missing_rules',postcode:value,profile};
    if(!isAustralianPostcode(value))return{available:null,state:'invalid',reason:'invalid_postcode',postcode:value,profile};
    if(contains(parsed.excluded,value))return{available:false,state:'unavailable',reason:'excluded',postcode:value,profile};
    if(contains(parsed.included,value))return{available:true,state:'available',reason:'included',postcode:value,profile};
    return{available:false,state:'unavailable',reason:'not_included',postcode:value,profile};
  };
  window.AWAInstallationCoverage={parseRules,evaluate,isAustralianPostcode};
})();
